import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import initScrollTrigger from '../helpers/initScrollTrigger';
// import {debounce} from 'throttle-debounce';

// import сustomPageScroll from './custom-scroll';
import {IS_TOUCH, IS_PHONE, BREAKPOINTS} from '../helpers/consts';
import { getNewLottieAnim, initScrollLottie } from '../helpers/lottie';
import refreshScrollAndTriggers from '../helpers/refreshScrollTriggers';

gsap.registerPlugin(ScrollTrigger);

function getRandomInt(min, max) {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min + 1) + min);
}



export default () => {

	initScrollTrigger();
	const sections = document.querySelectorAll('.js-parallax-section');
	sections.forEach((section) => {
		const itemWrappers = section.querySelectorAll('.js-parallax-section-item-wrapper');
		const lottieElems = section.querySelectorAll('.js-about-parallax-lottie');

		if(!IS_PHONE) {
			itemWrappers.forEach((wrapper, i) => {
				// const isEven = i % 2 == 0;
				const item = wrapper.querySelector('.js-parallax-section-item');
				gsap.to(item, {
					transformOrigin: 'center center',
					yPercent: () => {
						return -getRandomInt(50, 130);
					},
					xPercent: () => {
						// return isEven ? -getRandomInt(10,50) : getRandomInt(10,50)
						const direction = Math.random() < 0.5 ? -1 : 1;
						return direction * getRandomInt(10, 20);
					},
					rotation: () => {
						const direction = Math.random() < 0.5 ? -1 : 1;
						// return isEven ? getRandomInt(10,50) : -getRandomInt(10,50)
						return direction * getRandomInt(10, 25);
					},
					ease: 'none',
					scrollTrigger: {
						trigger: wrapper,
						start: 'top bottom',
						end: 'bottom+=300 top',
						scrub: true
					},
				});
			});
		};

		lottieElems.forEach((lottieEl) => {
			initScrollLottie(lottieEl, {
				loop: true,
				autoplay: true,
			}, () => {
				refreshScrollAndTriggers();
			});
		});

	});


};
